import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2, Save, Loader2 } from "lucide-react";
import { inp } from "./ListingForm";

export default function CategoriesManager() {
  const [cats, setCats] = useState(null);
  const [name, setName] = useState("");

  const load = () => api.get("/admin/marketplace/categories").then((r) => setCats(r.data)).catch(() => toast.error("Could not load categories"));
  useEffect(() => { load(); }, []);

  const edit = (id, k, v) => setCats(cats.map((c) => (c.id === id ? { ...c, [k]: v } : c)));
  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/admin/marketplace/categories", { name, order: cats.length }); setName(""); toast.success("Category added"); load(); }
    catch (err) { toast.error(err?.response?.data?.detail || "Add failed"); }
  };
  const save = async (c) => {
    try { await api.put(`/admin/marketplace/categories/${c.id}`, { name: c.name, description: c.description || "", image_url: c.image_url || "", order: Number(c.order) || 0, active: c.active }); toast.success("Saved"); load(); }
    catch { toast.error("Save failed"); }
  };
  const remove = async (c) => {
    if (!window.confirm(`Delete category "${c.name}"?`)) return;
    try { await api.delete(`/admin/marketplace/categories/${c.id}`); toast.success("Deleted"); load(); }
    catch (err) { toast.error(err?.response?.data?.detail || "Delete failed"); }
  };

  if (!cats) return <Loader2 className="animate-spin text-[#D4AF37]" />;
  return (
    <div data-testid="mkt-categories-manager" className="space-y-4">
      <form onSubmit={add} className="flex gap-3 max-w-lg">
        <input required data-testid="mkt-cat-new-name" placeholder="New category name" className={inp} value={name} onChange={(e) => setName(e.target.value)} />
        <button data-testid="mkt-cat-add" className="btn-gold px-4 rounded text-xs tracking-widest uppercase inline-flex items-center gap-2 whitespace-nowrap"><Plus size={14} /> Add</button>
      </form>
      <div className="space-y-2">
        {cats.map((c) => (
          <div key={c.id} data-testid={`mkt-cat-row-${c.key}`} className="grid grid-cols-12 gap-3 items-center luxury-card rounded-lg p-3">
            <input className={`${inp} col-span-3`} value={c.name} onChange={(e) => edit(c.id, "name", e.target.value)} aria-label="Name" />
            <input className={`${inp} col-span-5`} value={c.image_url || ""} placeholder="Image URL" onChange={(e) => edit(c.id, "image_url", e.target.value)} aria-label="Image URL" />
            <input type="number" className={`${inp} col-span-1`} value={c.order} onChange={(e) => edit(c.id, "order", e.target.value)} aria-label="Order" />
            <label className="col-span-1 flex items-center gap-1 text-xs text-neutral-400"><input type="checkbox" checked={c.active} onChange={(e) => edit(c.id, "active", e.target.checked)} className="accent-[#D4AF37]" /> On</label>
            <div className="col-span-2 text-right">
              <button onClick={() => save(c)} data-testid={`mkt-cat-save-${c.key}`} className="p-2 text-neutral-300 hover:text-[#D4AF37]" title="Save"><Save size={14} /></button>
              <button onClick={() => remove(c)} data-testid={`mkt-cat-delete-${c.key}`} className="p-2 text-neutral-400 hover:text-red-400" title="Delete"><Trash2 size={14} /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
